import api from "./api";

export const mediaService = {
  /**
   * Uploads media file with optional ObjectId association
   * @param {File} file - The file to upload
   * @param {string} [objectId=null] - Optional ObjectId to associate with the media
   * @param {Object} [additionalData={}] - Additional form data to include
   * @returns {Promise<Object>} API response
   */
  mobileUploadMedia: async (file, objectId = null, additionalData = {}) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      // Add ObjectId if provided
      if (objectId) {
        formData.append("ObjectId", objectId);
      }

      // Append any additional data
      for (const key in additionalData) {
        if (additionalData.hasOwnProperty(key)) {
          formData.append(key, additionalData[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // Optional: Add progress tracking
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          console.log(`Upload progress: ${percentCompleted}%`);
        },
      };

      const response = await api.post("/mobileUploadMedia", formData, config);
      return response.data;
    } catch (error) {
      console.error("Error uploading media:", error);
      throw error;
    }
  },
};
